export const parseEdges = <
  NodeType,
  EdgeType extends ({ node?: NodeType | null } | null)[],
  parsedEdgeType
>(
  edges: EdgeType,
  callback: (node: NodeType) => parsedEdgeType,
) =>
  edges.reduce((lessons: parsedEdgeType[], edge) => {
    if (!edge?.node) {
      return lessons;
    }

    return [...lessons, callback(edge.node)];
  }, []);
